(function () {
	function onReady(callback) {
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', callback);
			return;
		}

		callback();
	}

	function closestElement(element, selector) {
		if (!element) {
			return null;
		}

		var current = element;
		var matcher =
			current.matches ||
			current.msMatchesSelector ||
			current.webkitMatchesSelector;

		while (current && current.nodeType === 1) {
			if (matcher && matcher.call(current, selector)) {
				return current;
			}
			current = current.parentElement;
		}

		return null;
	}

	function getWindowOrigin() {
		return (
			window.location.origin ||
			window.location.protocol + '//' + window.location.host
		);
	}

	function initViewSwitch(root) {
		var buttons = root.querySelectorAll('[data-library-view-btn]');
		var views = root.querySelectorAll('[data-library-view]');
		var lazyViews = {};
		var lazyViewRequests = {};
		var lazyFragmentQueues = {};
		var lazyFragmentPreload = 400;
		var lazyFragmentRequestDelay = 750;
		var lazyFragmentMaxRetries = 4;
		var lazyFragmentRetryBaseDelay = 1000;
		var materialSourceUrls = {
			'm49-bioplastic':
				root.getAttribute('data-library-material-source-m49-bioplastic') ||
				'/collections/m49?view=library-fiches-grid',
			'hx-hard-acetate':
				root.getAttribute('data-library-material-source-hx-hard-acetate') ||
				'/collections/hx?view=library-fiches-grid',
		};
		var activeMaterialSources = [];
		var completedMaterialSources = {};
		var materialSourceLoadToken = 0;

		if (!buttons.length || !views.length) {
			return;
		}

		function getView(viewName) {
			for (var i = 0; i < views.length; i += 1) {
				if (views[i].getAttribute('data-library-view') === viewName) {
					return views[i];
				}
			}

			return null;
		}

		function includesValue(list, value) {
			for (var i = 0; i < list.length; i += 1) {
				if (list[i] === value) {
					return true;
				}
			}

			return false;
		}

		function normalizeMaterialSources(sourceNames) {
			var normalized = [];

			for (var i = 0; i < sourceNames.length; i += 1) {
				var sourceName = sourceNames[i];

				if (
					materialSourceUrls[sourceName] &&
					!includesValue(normalized, sourceName)
				) {
					normalized.push(sourceName);
				}
			}

			return normalized;
		}

		function getSelectedView() {
			if (!window.URLSearchParams) {
				return 'fiches';
			}

			var viewName =
				new URLSearchParams(window.location.search).get('view') || 'fiches';

			if (viewName !== 'moodboard') {
				return 'fiches';
			}

			return viewName;
		}

		function getUrlForView(viewName) {
			var nextUrl = new URL(window.location.href);
			nextUrl.searchParams.set('view', viewName);
			return nextUrl.pathname + nextUrl.search + nextUrl.hash;
		}

		function updateViewUrl(viewName) {
			if (typeof root.libraryV2UpdateUrl === 'function') {
				root.libraryV2UpdateUrl({ viewName: viewName });
				return;
			}

			if (!window.history || !window.history.pushState) {
				window.location.href = getUrlForView(viewName);
				return;
			}

			window.history.pushState(null, '', getUrlForView(viewName));
		}

		function applyLibraryFilters() {
			if (typeof root.libraryV2ApplyFilters === 'function') {
				root.libraryV2ApplyFilters();
			}
		}

		function hasFragmentPlaceholders(queue) {
			return Boolean(
				queue.view.querySelector('[data-library-lazy-fragment-url]'),
			);
		}

		function shouldKeepFragmentQueueOpen(viewName, queue) {
			return (
				hasFragmentPlaceholders(queue) ||
				(viewName === 'fiches' && activeMaterialSources.length)
			);
		}

		function shouldLoadFragmentPlaceholder(viewName, placeholder) {
			if (placeholder.getAttribute('data-library-lazy-failed') === 'true') {
				return false;
			}

			if (viewName !== 'fiches') {
				return true;
			}

			if (activeMaterialSources.length) {
				return includesValue(
					activeMaterialSources,
					placeholder.getAttribute('data-library-material-source'),
				);
			}

			if (
				typeof root.libraryV2LazyFragmentMatchesSelectedFilters !== 'function'
			) {
				return true;
			}

			return root.libraryV2LazyFragmentMatchesSelectedFilters(
				placeholder.getAttribute('data-library-lazy-filter-tags') || '',
			);
		}

		function getNextFragmentPlaceholder(queue) {
			var placeholders = queue.view.querySelectorAll(
				'[data-library-lazy-fragment-url]',
			);
			var viewName = queue.view.getAttribute('data-library-view');

			for (var i = 0; i < placeholders.length; i += 1) {
				if (
					shouldLoadFragmentPlaceholder(viewName, placeholders[i]) &&
					getFragmentRetryAt(placeholders[i]) <= Date.now()
				) {
					return placeholders[i];
				}
			}

			return null;
		}

		function getNextFragmentRetryDelay(queue) {
			var placeholders = queue.view.querySelectorAll(
				'[data-library-lazy-fragment-url]',
			);
			var nextRetryAt = 0;
			var now = Date.now();
			var retryAt;
			var viewName = queue.view.getAttribute('data-library-view');

			for (var i = 0; i < placeholders.length; i += 1) {
				if (!shouldLoadFragmentPlaceholder(viewName, placeholders[i])) {
					continue;
				}

				retryAt = getFragmentRetryAt(placeholders[i]);

				if (retryAt > now && (!nextRetryAt || retryAt < nextRetryAt)) {
					nextRetryAt = retryAt;
				}
			}

			if (!nextRetryAt) {
				return null;
			}

			return Math.max(nextRetryAt - now, 0);
		}

		function isFragmentNearViewport(placeholder) {
			var rect = placeholder.getBoundingClientRect();
			var viewportHeight =
				window.innerHeight || document.documentElement.clientHeight;

			return (
				rect.top <= viewportHeight + lazyFragmentPreload &&
				rect.bottom >= -lazyFragmentPreload
			);
		}

		function getFragmentRetryCount(placeholder) {
			return (
				parseInt(
					placeholder.getAttribute('data-library-lazy-retry-count') || '0',
					10,
				) || 0
			);
		}

		function getFragmentRetryAt(placeholder) {
			return (
				parseInt(
					placeholder.getAttribute('data-library-lazy-retry-at') || '0',
					10,
				) || 0
			);
		}

		function getFragmentRetryAfterDelay(response) {
			var retryAfter = response.headers
				? response.headers.get('Retry-After')
				: null;
			var retryAfterDate;
			var retryAfterSeconds;

			if (!retryAfter) {
				return 0;
			}

			retryAfterSeconds = parseInt(retryAfter, 10);

			if (!isNaN(retryAfterSeconds)) {
				return Math.max(retryAfterSeconds * 1000, 0);
			}

			retryAfterDate = Date.parse(retryAfter);

			if (!isNaN(retryAfterDate)) {
				return Math.max(retryAfterDate - Date.now(), 0);
			}

			return 0;
		}

		function getFragmentRetryDelay(error, retryCount) {
			if (error && error.retryAfterDelay) {
				return error.retryAfterDelay;
			}

			return Math.min(
				lazyFragmentRetryBaseDelay * Math.pow(2, Math.max(retryCount - 1, 0)),
				15000,
			);
		}

		function removeFragmentStatus(placeholder, resetRetryCount) {
			var status = placeholder.querySelector('[data-library-lazy-status]');

			placeholder.classList.remove('has-error');
			placeholder.removeAttribute('data-library-lazy-failed');
			placeholder.removeAttribute('data-library-lazy-retry-at');

			if (resetRetryCount) {
				placeholder.removeAttribute('data-library-lazy-retry-count');
			}

			if (status && status.parentNode) {
				status.parentNode.removeChild(status);
			}
		}

		function setFragmentLoading(placeholder, isLoading) {
			placeholder.classList.toggle('is-loading', isLoading);

			if (isLoading) {
				placeholder.setAttribute('aria-busy', 'true');
			} else {
				placeholder.removeAttribute('aria-busy');
			}
		}

		function showFragmentRetryButton(placeholder) {
			var button;
			var status = placeholder.querySelector('[data-library-lazy-status]');

			if (!status) {
				status = document.createElement('div');
				status.className = 'library-v2__lazy-status';
				status.setAttribute('data-library-lazy-status', '');
				placeholder.appendChild(status);
			}

			status.innerHTML = '';

			button = document.createElement('button');
			button.type = 'button';
			button.className = 'library-v2__lazy-retry-button';
			button.setAttribute('data-library-lazy-retry', '');
			button.textContent = 'Retry loading products';
			status.appendChild(button);
		}

		function copyFragmentPlaceholderMetadata(sourcePlaceholder, wrapper) {
			var filterTags = sourcePlaceholder.getAttribute(
				'data-library-lazy-filter-tags',
			);
			var materialSource = sourcePlaceholder.getAttribute(
				'data-library-material-source',
			);
			var placeholders = wrapper.querySelectorAll(
				'[data-library-lazy-fragment-url]',
			);

			for (var i = 0; i < placeholders.length; i += 1) {
				placeholders[i].classList.add('library-v2__lazy-fragment');

				if (
					filterTags !== null &&
					!placeholders[i].hasAttribute('data-library-lazy-filter-tags')
				) {
					placeholders[i].setAttribute(
						'data-library-lazy-filter-tags',
						filterTags,
					);
				}

				if (
					materialSource !== null &&
					!placeholders[i].hasAttribute('data-library-material-source')
				) {
					placeholders[i].setAttribute(
						'data-library-material-source',
						materialSource,
					);
				}
			}
		}

		function markTopLevelFragmentElements(wrapper, materialSource) {
			var child = wrapper.firstElementChild;

			while (child) {
				child.setAttribute('data-library-material-source', materialSource);
				child = child.nextElementSibling;
			}
		}

		function getComparableFragmentUrl(url) {
			var link;

			if (!url) {
				return '';
			}

			link = document.createElement('a');
			link.href = url;

			if (
				link.protocol &&
				link.host &&
				link.protocol + '//' + link.host !== window.location.origin
			) {
				return link.href;
			}

			return link.pathname + link.search + link.hash;
		}

		function getSingleMeaningfulFragmentElement(wrapper) {
			var child = wrapper.firstChild;
			var meaningfulElement = null;

			while (child) {
				if (child.nodeType === 1) {
					if (meaningfulElement) {
						return null;
					}

					meaningfulElement = child;
				} else if (
					child.nodeType === 3 &&
					child.nodeValue.replace(/\s/g, '') !== ''
				) {
					return null;
				}

				child = child.nextSibling;
			}

			return meaningfulElement;
		}

		function hasMeaningfulFragmentContent(wrapper) {
			var child = wrapper.firstChild;

			while (child) {
				if (
					child.nodeType === 1 ||
					(child.nodeType === 3 && child.nodeValue.replace(/\s/g, '') !== '')
				) {
					return true;
				}

				child = child.nextSibling;
			}

			return false;
		}

		function fragmentReturnedSamePlaceholder(wrapper, fragmentUrl) {
			var lazyUrl;
			var singleElement = getSingleMeaningfulFragmentElement(wrapper);

			if (
				!singleElement ||
				!singleElement.hasAttribute('data-library-lazy-fragment-url')
			) {
				return false;
			}

			lazyUrl = singleElement.getAttribute('data-library-lazy-fragment-url');
			return (
				getComparableFragmentUrl(lazyUrl) ===
				getComparableFragmentUrl(fragmentUrl)
			);
		}

		function isFullPageFragmentHtml(html) {
			return /<\/?(html|head|body)(\s|>)/i.test(html);
		}

		function removeFragmentPlaceholder(placeholder) {
			if (placeholder.parentNode) {
				placeholder.parentNode.removeChild(placeholder);
			}
		}

		function markFragmentPlaceholderFailed(placeholder) {
			setFragmentLoading(placeholder, false);
			placeholder.classList.add('has-error');
			placeholder.setAttribute('data-library-lazy-failed', 'true');
			placeholder.removeAttribute('data-library-lazy-retry-at');
			showFragmentRetryButton(placeholder);
		}

		function syncMaterialSourceCompletion(materialSource) {
			if (materialSource) {
				completedMaterialSources[materialSource] =
					!getMaterialSourcePlaceholder(materialSource);
			}
		}

		function clearObservedFragmentPlaceholders(queue) {
			var placeholders = queue.view.querySelectorAll(
				'[data-library-lazy-fragment-url].is-observed',
			);

			for (var i = 0; i < placeholders.length; i += 1) {
				placeholders[i].classList.remove('is-observed');
			}
		}

		function observeFragmentPlaceholder(queue, placeholder) {
			clearObservedFragmentPlaceholders(queue);

			if (placeholder) {
				placeholder.classList.add('is-observed');
			}
		}

		function cleanupFragmentQueue(queue) {
			if (queue.observer) {
				queue.observer.disconnect();
				queue.observer = null;
			}

			if (queue.fallbackCheck) {
				window.removeEventListener('scroll', queue.fallbackCheck);
				window.removeEventListener('resize', queue.fallbackCheck);
				queue.fallbackCheck = null;
			}

			if (queue.fallbackFrame) {
				window.cancelAnimationFrame(queue.fallbackFrame);
				queue.fallbackFrame = null;
			}

			if (queue.throttleTimer) {
				window.clearTimeout(queue.throttleTimer);
				queue.throttleTimer = null;
			}

			if (queue.retryTimer) {
				window.clearTimeout(queue.retryTimer);
				queue.retryTimer = null;
			}

			clearObservedFragmentPlaceholders(queue);
		}

		function createFragmentQueue(view) {
			return {
				view: view,
				loading: false,
				complete: false,
				observer: null,
				fallbackCheck: null,
				fallbackFrame: null,
				lastRequestStartedAt: 0,
				throttleTimer: null,
				retryTimer: null,
			};
		}

		function completeFragmentQueue(viewName, queue) {
			cleanupFragmentQueue(queue);
			queue.complete = true;
			lazyViews[viewName] = true;
			lazyViewRequests[viewName] = null;
		}

		function scheduleFragmentRetry(viewName, queue, delay) {
			cleanupFragmentQueue(queue);

			queue.retryTimer = window.setTimeout(function () {
				queue.retryTimer = null;

				if (!queue.view.hidden) {
					observeNextFragment(viewName);
				}
			}, delay);
		}

		function handleFragmentFailure(viewName, queue, placeholder, error) {
			var retryAt;
			var retryCount;
			var retryDelay;

			setFragmentLoading(placeholder, false);

			if (!placeholder.parentNode) {
				observeNextFragment(viewName);
				return;
			}

			retryCount = getFragmentRetryCount(placeholder) + 1;
			placeholder.setAttribute('data-library-lazy-retry-count', retryCount);

			if (retryCount <= lazyFragmentMaxRetries) {
				retryDelay = getFragmentRetryDelay(error, retryCount);
				retryAt = Date.now() + retryDelay;
				placeholder.setAttribute('data-library-lazy-retry-at', retryAt);
				observeNextFragment(viewName);
				return;
			}

			placeholder.classList.add('has-error');
			placeholder.setAttribute('data-library-lazy-failed', 'true');
			placeholder.removeAttribute('data-library-lazy-retry-at');
			showFragmentRetryButton(placeholder);
			observeNextFragment(viewName);
		}

		function loadFragment(viewName, placeholder, skipThrottle) {
			var elapsedSinceLastRequest;
			var fragmentUrl;
			var materialSource;
			var queue = lazyFragmentQueues[viewName];
			var throttleDelay;

			if (
				!queue ||
				queue.loading ||
				queue.complete ||
				!placeholder ||
				!placeholder.parentNode
			) {
				return Promise.resolve();
			}

			if (queue.view.hidden) {
				cleanupFragmentQueue(queue);
				return Promise.resolve();
			}

			if (!shouldLoadFragmentPlaceholder(viewName, placeholder)) {
				observeNextFragment(viewName);
				return Promise.resolve();
			}

			elapsedSinceLastRequest = Date.now() - queue.lastRequestStartedAt;
			throttleDelay = Math.max(
				lazyFragmentRequestDelay - elapsedSinceLastRequest,
				0,
			);

			if (!skipThrottle && throttleDelay > 0) {
				cleanupFragmentQueue(queue);
				queue.throttleTimer = window.setTimeout(function () {
					queue.throttleTimer = null;
					loadFragment(viewName, placeholder, true);
				}, throttleDelay);

				return Promise.resolve();
			}

			cleanupFragmentQueue(queue);
			queue.loading = true;
			queue.lastRequestStartedAt = Date.now();
			fragmentUrl = placeholder.getAttribute('data-library-lazy-fragment-url');
			materialSource = placeholder.getAttribute('data-library-material-source');
			removeFragmentStatus(placeholder, false);
			setFragmentLoading(placeholder, true);

			lazyViewRequests[viewName] = fetch(fragmentUrl, {
				credentials: 'same-origin',
			})
				.then(function (response) {
					var error;

					if (!response.ok) {
						error = new Error('Unable to load library view fragment');
						error.retryAfterDelay = getFragmentRetryAfterDelay(response);
						throw error;
					}

					return response.text();
				})
				.then(function (html) {
					var wrapper = document.createElement('div');
					wrapper.innerHTML = html;

					if (isFullPageFragmentHtml(html)) {
						markFragmentPlaceholderFailed(placeholder);

						queue.loading = false;
						lazyViewRequests[viewName] = null;
						applyLibraryFilters();
						observeNextFragment(viewName);
						return;
					}

					if (!hasMeaningfulFragmentContent(wrapper)) {
						removeFragmentPlaceholder(placeholder);
						syncMaterialSourceCompletion(materialSource);

						queue.loading = false;
						lazyViewRequests[viewName] = null;
						applyLibraryFilters();
						observeNextFragment(viewName);
						return;
					}

					if (fragmentReturnedSamePlaceholder(wrapper, fragmentUrl)) {
						markFragmentPlaceholderFailed(placeholder);

						queue.loading = false;
						lazyViewRequests[viewName] = null;
						applyLibraryFilters();
						observeNextFragment(viewName);
						return;
					}

					copyFragmentPlaceholderMetadata(placeholder, wrapper);

					if (materialSource) {
						markTopLevelFragmentElements(wrapper, materialSource);
					}

					while (wrapper.firstChild && placeholder.parentNode) {
						placeholder.parentNode.insertBefore(wrapper.firstChild, placeholder);
					}

					removeFragmentPlaceholder(placeholder);
					syncMaterialSourceCompletion(materialSource);

					queue.loading = false;
					lazyViewRequests[viewName] = null;
					applyLibraryFilters();
					observeNextFragment(viewName);
				})
				.catch(function (error) {
					queue.loading = false;
					lazyViewRequests[viewName] = null;
					handleFragmentFailure(viewName, queue, placeholder, error);
				});

			return lazyViewRequests[viewName];
		}

		function loadNextFragment(viewName) {
			var queue = lazyFragmentQueues[viewName];
			var placeholder;
			var retryDelay;

			if (
				!queue ||
				queue.loading ||
				queue.complete ||
				queue.throttleTimer ||
				queue.retryTimer
			) {
				return Promise.resolve();
			}

			placeholder = getNextFragmentPlaceholder(queue);

			if (!placeholder) {
				retryDelay = getNextFragmentRetryDelay(queue);

				if (retryDelay !== null) {
					scheduleFragmentRetry(viewName, queue, retryDelay);
					return Promise.resolve();
				}

				if (shouldKeepFragmentQueueOpen(viewName, queue)) {
					cleanupFragmentQueue(queue);
				} else {
					completeFragmentQueue(viewName, queue);
				}

				return Promise.resolve();
			}

			return loadFragment(viewName, placeholder, false);
		}

		function getFichesGrid() {
			var fichesView = getView('fiches');

			if (!fichesView) {
				return null;
			}

			return fichesView.querySelector('.library-v2__fiches-grid');
		}

		function getMaterialSourceSelector(sourceName) {
			return '[data-library-material-source="' + sourceName + '"]';
		}

		function getMaterialSourcePlaceholder(sourceName) {
			var grid = getFichesGrid();

			if (!grid) {
				return null;
			}

			return grid.querySelector(
				getMaterialSourceSelector(sourceName) +
					'[data-library-lazy-fragment-url]',
			);
		}

		function hasMaterialSourceProducts(sourceName) {
			var grid = getFichesGrid();

			if (!grid) {
				return false;
			}

			return Boolean(
				grid.querySelector(
					getMaterialSourceSelector(sourceName) +
						'[data-library-product-handle]',
				),
			);
		}

		function createMaterialSourcePlaceholder(sourceName) {
			var placeholder = document.createElement('div');
			placeholder.className = 'library-v2__lazy-fragment';
			placeholder.setAttribute(
				'data-library-lazy-fragment-url',
				materialSourceUrls[sourceName],
			);
			placeholder.setAttribute('data-library-material-source', sourceName);
			return placeholder;
		}

		function syncMaterialSourcePlaceholders(sourceNames) {
			var grid = getFichesGrid();
			var insertedSource = false;
			var materialSourceNodes;

			if (!grid) {
				return;
			}

			for (var sourceKey in materialSourceUrls) {
				if (
					Object.prototype.hasOwnProperty.call(materialSourceUrls, sourceKey) &&
					!includesValue(sourceNames, sourceKey)
				) {
					completedMaterialSources[sourceKey] = false;
				}
			}

			materialSourceNodes = grid.querySelectorAll(
				'[data-library-material-source]',
			);

			for (var i = 0; i < materialSourceNodes.length; i += 1) {
				var nodeSource = materialSourceNodes[i].getAttribute(
					'data-library-material-source',
				);

				if (
					!includesValue(sourceNames, nodeSource) &&
					materialSourceNodes[i].parentNode
				) {
					materialSourceNodes[i].parentNode.removeChild(materialSourceNodes[i]);
				}
			}

			for (var j = 0; j < sourceNames.length; j += 1) {
				var sourceName = sourceNames[j];

				if (
					!completedMaterialSources[sourceName] &&
					!grid.querySelector(getMaterialSourceSelector(sourceName))
				) {
					grid.appendChild(createMaterialSourcePlaceholder(sourceName));
					insertedSource = true;
				}
			}

			if (insertedSource && lazyFragmentQueues.fiches) {
				lazyFragmentQueues.fiches.complete = false;
				lazyViews.fiches = false;
			}
		}

		function ensureFragmentQueue(viewName, view) {
			if (!lazyFragmentQueues[viewName]) {
				lazyFragmentQueues[viewName] = createFragmentQueue(view);
			}

			return lazyFragmentQueues[viewName];
		}

		function loadMaterialSource(sourceName) {
			var view = getView('fiches');
			var queue;
			var placeholder;

			if (
				!view ||
				view.hidden ||
				completedMaterialSources[sourceName] ||
				hasMaterialSourceProducts(sourceName)
			) {
				return Promise.resolve(false);
			}

			queue = ensureFragmentQueue('fiches', view);

			if (
				queue.loading ||
				queue.complete ||
				queue.throttleTimer ||
				queue.retryTimer
			) {
				return Promise.resolve(false);
			}

			placeholder = getMaterialSourcePlaceholder(sourceName);

			if (!placeholder) {
				return Promise.resolve(false);
			}

			return loadFragment('fiches', placeholder, true).then(function () {
				return true;
			});
		}

		function loadMaterialSources(sourceNames, token, index) {
			if (token !== materialSourceLoadToken || index >= sourceNames.length) {
				observeNextFragment('fiches');
				return;
			}

			if (!includesValue(activeMaterialSources, sourceNames[index])) {
				loadMaterialSources(sourceNames, token, index + 1);
				return;
			}

			loadMaterialSource(sourceNames[index]).then(function () {
				loadMaterialSources(sourceNames, token, index + 1);
			});
		}

		function setActiveMaterialSources(sourceNames) {
			var normalizedSources = normalizeMaterialSources(sourceNames);
			activeMaterialSources = normalizedSources;
			materialSourceLoadToken += 1;

			syncMaterialSourcePlaceholders(normalizedSources);

			if (normalizedSources.length) {
				loadMaterialSources(normalizedSources, materialSourceLoadToken, 0);
				return;
			}

			observeNextFragment('fiches');
		}

		function observeNextFragment(viewName) {
			var queue = lazyFragmentQueues[viewName];
			var placeholder;
			var retryDelay;

			if (
				!queue ||
				queue.loading ||
				queue.complete ||
				queue.throttleTimer ||
				queue.retryTimer
			) {
				return;
			}

			if (queue.view.hidden) {
				cleanupFragmentQueue(queue);
				return;
			}

			placeholder = getNextFragmentPlaceholder(queue);

			if (!placeholder) {
				retryDelay = getNextFragmentRetryDelay(queue);

				if (retryDelay !== null) {
					scheduleFragmentRetry(viewName, queue, retryDelay);
					return;
				}

				if (shouldKeepFragmentQueueOpen(viewName, queue)) {
					cleanupFragmentQueue(queue);
				} else {
					completeFragmentQueue(viewName, queue);
				}

				return;
			}

			cleanupFragmentQueue(queue);
			observeFragmentPlaceholder(queue, placeholder);

			if (getFragmentRetryAt(placeholder) > Date.now()) {
				scheduleFragmentRetry(
					viewName,
					queue,
					getFragmentRetryAt(placeholder) - Date.now(),
				);
				return;
			}

			if (isFragmentNearViewport(placeholder)) {
				loadNextFragment(viewName);
				return;
			}

			if ('IntersectionObserver' in window) {
				queue.observer = new IntersectionObserver(
					function (entries) {
						for (var i = 0; i < entries.length; i += 1) {
							if (entries[i].isIntersecting) {
								loadNextFragment(viewName);
								break;
							}
						}
					},
					{
						rootMargin: lazyFragmentPreload + 'px 0px',
					},
				);
				queue.observer.observe(placeholder);
				return;
			}

			queue.fallbackCheck = function () {
				if (queue.fallbackFrame) {
					return;
				}

				queue.fallbackFrame = window.requestAnimationFrame(function () {
					queue.fallbackFrame = null;

					if (isFragmentNearViewport(placeholder)) {
						loadNextFragment(viewName);
					}
				});
			};

			window.addEventListener('scroll', queue.fallbackCheck);
			window.addEventListener('resize', queue.fallbackCheck);
		}

		function loadLazyFragments(viewName, view) {
			if (!lazyFragmentQueues[viewName]) {
				lazyFragmentQueues[viewName] = createFragmentQueue(view);
			}

			observeNextFragment(viewName);

			return lazyViewRequests[viewName] || Promise.resolve();
		}

		root.libraryV2RefreshLazyFragments = function () {
			for (var viewName in lazyFragmentQueues) {
				if (
					Object.prototype.hasOwnProperty.call(lazyFragmentQueues, viewName) &&
					!lazyFragmentQueues[viewName].view.hidden
				) {
					observeNextFragment(viewName);
				}
			}
		};

		root.libraryV2SetActiveMaterialSources = setActiveMaterialSources;

		if (typeof root.libraryV2GetSelectedMaterialSources === 'function') {
			setActiveMaterialSources(root.libraryV2GetSelectedMaterialSources());
		}

		root.addEventListener('click', function (event) {
			var placeholder;
			var retryButton = closestElement(
				event.target,
				'[data-library-lazy-retry]',
			);
			var view;

			if (!retryButton) {
				return;
			}

			placeholder = closestElement(
				retryButton,
				'[data-library-lazy-fragment-url]',
			);
			view = placeholder
				? closestElement(placeholder, '[data-library-view]')
				: null;

			if (!placeholder || !view) {
				return;
			}

			event.preventDefault();
			removeFragmentStatus(placeholder, true);
			setFragmentLoading(placeholder, false);
			observeNextFragment(view.getAttribute('data-library-view'));
		});

		function loadLazyView(viewName) {
			var view = getView(viewName);
			var fragmentPlaceholders;

			if (!view) {
				return Promise.resolve();
			}

			fragmentPlaceholders = view.querySelectorAll(
				'[data-library-lazy-fragment-url]',
			);

			if (
				lazyViews[viewName] ||
				(!view.getAttribute('data-library-lazy-view-url') &&
					!fragmentPlaceholders.length)
			) {
				return Promise.resolve();
			}

			if (fragmentPlaceholders.length) {
				return loadLazyFragments(viewName, view);
			}

			if (lazyViewRequests[viewName]) {
				return lazyViewRequests[viewName];
			}

			lazyViewRequests[viewName] = fetch(
				view.getAttribute('data-library-lazy-view-url'),
				{
					credentials: 'same-origin',
				},
			)
				.then(function (response) {
					if (!response.ok) {
						throw new Error('Unable to load library view');
					}

					return response.text();
				})
				.then(function (html) {
					view.innerHTML = html;
					lazyViews[viewName] = true;

					applyLibraryFilters();
				})
				.catch(function () {
					lazyViewRequests[viewName] = null;
				});

			return lazyViewRequests[viewName];
		}

		function prefetchLazyView(viewName) {
			var view = getView(viewName);

			if (!view || lazyViews[viewName] || lazyViewRequests[viewName]) {
				return;
			}

			if (!view.getAttribute('data-library-lazy-view-url')) {
				return;
			}

			loadLazyView(viewName);
		}

		function getActiveViewName() {
			for (var i = 0; i < views.length; i += 1) {
				if (!views[i].hidden) {
					return views[i].getAttribute('data-library-view') || 'fiches';
				}
			}

			return getSelectedView();
		}

		function setView(viewName, shouldUpdateUrl) {
			var index;
			var selectedView = getView(viewName) ? viewName : 'fiches';
			var viewLoadPromise;

			for (index = 0; index < views.length; index += 1) {
				var view = views[index];
				var currentViewName = view.getAttribute('data-library-view');
				var isActive = currentViewName === selectedView;
				view.hidden = !isActive;
				view.setAttribute('aria-hidden', isActive ? 'false' : 'true');
				view.classList.toggle('is-active', isActive);

				if (!isActive && lazyFragmentQueues[currentViewName]) {
					cleanupFragmentQueue(lazyFragmentQueues[currentViewName]);
				}
			}

			for (index = 0; index < buttons.length; index += 1) {
				var button = buttons[index];
				var buttonIsActive =
					button.getAttribute('data-library-view-btn') === selectedView;
				var buttonWrapper = button.parentElement;
				button.classList.toggle('is-active', buttonIsActive);
				button.setAttribute('aria-selected', buttonIsActive ? 'true' : 'false');
				if (buttonWrapper) {
					buttonWrapper.classList.toggle('active', buttonIsActive);
				}
			}

			viewLoadPromise = loadLazyView(selectedView).then(function () {
				applyLibraryFilters();
			});

			if (
				selectedView === 'fiches' &&
				typeof root.libraryV2GetSelectedMaterialSources === 'function'
			) {
				setActiveMaterialSources(root.libraryV2GetSelectedMaterialSources());
			}

			if (shouldUpdateUrl) {
				updateViewUrl(selectedView);
			}

			return viewLoadPromise;
		}

		for (var i = 0; i < buttons.length; i += 1) {
			buttons[i].addEventListener('click', function (event) {
				event.preventDefault();
				var selectedView = event.currentTarget.getAttribute(
					'data-library-view-btn',
				);
				setView(selectedView, true);
			});

			buttons[i].addEventListener('mouseenter', function (event) {
				prefetchLazyView(
					event.currentTarget.getAttribute('data-library-view-btn'),
				);
			});

			buttons[i].addEventListener('focus', function (event) {
				prefetchLazyView(
					event.currentTarget.getAttribute('data-library-view-btn'),
				);
			});
		}

		root.libraryV2SetView = setView;
		root.libraryV2GetSelectedView = getActiveViewName;

		setView(getSelectedView(), false);
	}

	function initLibraryFilters(root) {
		var checkboxes = root.querySelectorAll('[data-library-filter]');
		var collectionFilters = root.querySelectorAll(
			'[data-library-collection-filter]',
		);
		var ficheItems = root.querySelectorAll('[data-library-fiche-item]');
		var collectionWrappers = root.querySelectorAll('[data-library-collection]');
		var moodboardCards = root.querySelectorAll('[data-library-moodboard-card]');
		var clearFilters = root.querySelector('[data-library-clear-filters]');
		var activeFilters = root.querySelector('[data-library-active-filters]');
		var selectedCollection = '';
		var moodboardResultsRequest = null;
		var moodboardExpandedEffect = '';
		var filterParamNames = [];
		var pendingScrollRestore = true;
		var scrollRestoreTimer = null;

		if (!checkboxes.length && !collectionFilters.length) {
			return;
		}

		function normalizeValue(value) {
			if (value === 'availability-moq') {
				return 'moq';
			}

			if (value === 'catalogue') {
				return 'catalog';
			}

			return value;
		}

		function collectSelectedFilters() {
			var selected = {};

			for (var i = 0; i < checkboxes.length; i += 1) {
				if (checkboxes[i].checked) {
					var group =
						checkboxes[i].getAttribute('data-library-filter-group') ||
						'availability';
					var value = normalizeValue(checkboxes[i].value);

					if (!selected[group]) {
						selected[group] = [];
					}

					selected[group].push(value);
				}
			}

			if (selectedCollection) {
				if (!selected.collection) {
					selected.collection = [];
				}

				if (!includesValue(selected.collection, selectedCollection)) {
					selected.collection.push(selectedCollection);
				}
			}

			return selected;
		}

		function getSelectedGroupCount(selected) {
			var count = 0;

			for (var group in selected) {
				if (
					Object.prototype.hasOwnProperty.call(selected, group) &&
					selected[group].length
				) {
					count += 1;
				}
			}

			return count;
		}

		function getSelectedGroupsExcept(selected, excludedGroup) {
			var filtered = {};

			for (var group in selected) {
				if (
					Object.prototype.hasOwnProperty.call(selected, group) &&
					group !== excludedGroup
				) {
					filtered[group] = selected[group];
				}
			}

			return filtered;
		}

		function selectedMatchesExpandedMoodboardEffect(selected) {
			return Boolean(
				moodboardExpandedEffect &&
				isMoodboardViewActive() &&
				getSelectedGroupCount(selected) === 1 &&
				selected.effects &&
				selected.effects.length === 1 &&
				selected.effects[0] === moodboardExpandedEffect,
			);
		}

		function syncMoodboardEffectSections(expandedEffect) {
			var moodboardEffectSections = root.querySelectorAll(
				'[data-library-moodboard-effect]',
			);

			for (var i = 0; i < moodboardEffectSections.length; i += 1) {
				var moodboardEffectSection = moodboardEffectSections[i];
				moodboardEffectSection.hidden =
					Boolean(expandedEffect) &&
					moodboardEffectSection.getAttribute(
						'data-library-moodboard-effect',
					) !== expandedEffect;
			}
		}

		function includesValue(list, value) {
			for (var i = 0; i < list.length; i += 1) {
				if (list[i] === value) {
					return true;
				}
			}

			return false;
		}

		function parseFilterTags(value) {
			var productValues = value ? value.split('|') : [''];
			var productTags = [];

			for (var i = 0; i < productValues.length; i += 1) {
				var tagValues = productValues[i].split(/\s+/);
				var tags = [];

				for (var j = 0; j < tagValues.length; j += 1) {
					var tagValue = normalizeValue(tagValues[j]);

					if (tagValue) {
						tags.push(tagValue);
					}
				}

				productTags.push(tags);
			}

			return productTags;
		}

		function tagsMatchSelectedGroups(tags, selected) {
			for (var group in selected) {
				if (Object.prototype.hasOwnProperty.call(selected, group)) {
					var groupValues = selected[group];
					var matchedGroup = false;

					for (var i = 0; i < groupValues.length; i += 1) {
						if (includesValue(tags, groupValues[i])) {
							matchedGroup = true;
							break;
						}
					}

					if (!matchedGroup) {
						return false;
					}
				}
			}

			return true;
		}

		function filterTagsMatchSelectedGroups(filterTags, selected) {
			var productTags = parseFilterTags(filterTags);

			for (var i = 0; i < productTags.length; i += 1) {
				if (tagsMatchSelectedGroups(productTags[i], selected)) {
					return true;
				}
			}

			return false;
		}

		root.libraryV2LazyFragmentMatchesSelectedFilters = function (filterTags) {
			var selected = collectSelectedFilters();

			if (getSelectedGroupCount(selected) === 0) {
				return true;
			}

			return filterTagsMatchSelectedGroups(filterTags || '', selected);
		};

		function getSelectedMaterialSources(selected) {
			var materials = selected.materials || [];
			var materialSources = [];

			if (includesValue(materials, 'm49-bioplastic')) {
				materialSources.push('m49-bioplastic');
			}

			if (includesValue(materials, 'hx-hard-acetate')) {
				materialSources.push('hx-hard-acetate');
			}

			return materialSources;
		}

		function getFilterGroup(checkbox) {
			return (
				checkbox.getAttribute('data-library-filter-group') || 'availability'
			);
		}

		function addUniqueParamName(names, name) {
			if (name && !includesValue(names, name)) {
				names.push(name);
			}
		}

		function getFilterParamNames() {
			var names = [];

			for (var i = 0; i < checkboxes.length; i += 1) {
				addUniqueParamName(names, getFilterGroup(checkboxes[i]));
			}

			addUniqueParamName(names, 'collection');

			return names;
		}

		function getSearchParams() {
			if (!window.URLSearchParams) {
				return null;
			}

			return new URLSearchParams(window.location.search);
		}

		function getUrlViewName() {
			var params = getSearchParams();
			var viewName = params ? params.get('view') : '';

			return viewName === 'moodboard' ? 'moodboard' : 'fiches';
		}

		function getUrlFilterValues(params, group) {
			var rawValues = [];
			var values = [];
			var singleValue;

			if (!params || !group) {
				return values;
			}

			if (typeof params.getAll === 'function') {
				rawValues = params.getAll(group);
			}

			if (!rawValues.length) {
				singleValue = params.get(group);

				if (singleValue) {
					rawValues = [singleValue];
				}
			}

			for (var i = 0; i < rawValues.length; i += 1) {
				var value = normalizeValue(rawValues[i]);

				if (value && !includesValue(values, value)) {
					values.push(value);
				}
			}

			return values;
		}

		function applyFiltersFromUrl() {
			var params = getSearchParams();
			var collectionValues;
			var matchedCollectionCheckbox = false;

			if (!params) {
				return;
			}

			selectedCollection = '';
			collectionValues = getUrlFilterValues(params, 'collection');

			for (var i = 0; i < checkboxes.length; i += 1) {
				var checkbox = checkboxes[i];
				var group = getFilterGroup(checkbox);
				var isChecked = includesValue(
					getUrlFilterValues(params, group),
					normalizeValue(checkbox.value),
				);

				checkbox.checked = isChecked;

				if (group === 'collection' && isChecked) {
					matchedCollectionCheckbox = true;
				}
			}

			if (
				collectionFilters.length &&
				!matchedCollectionCheckbox &&
				collectionValues.length
			) {
				selectedCollection = collectionValues[0];
			}

			moodboardExpandedEffect = '';
			resetMoodboardEffectExpansions();
		}

		function getSelectedViewName(viewName) {
			if (viewName) {
				return viewName === 'moodboard' ? 'moodboard' : 'fiches';
			}

			if (typeof root.libraryV2GetSelectedView === 'function') {
				return root.libraryV2GetSelectedView() === 'moodboard'
					? 'moodboard'
					: 'fiches';
			}

			return getUrlViewName();
		}

		function getCurrentPath() {
			return (
				window.location.pathname +
				window.location.search +
				window.location.hash
			);
		}

		function getLibraryStateUrl(options) {
			var nextUrl;
			var selected = collectSelectedFilters();
			var viewName = getSelectedViewName(options ? options.viewName : '');

			try {
				nextUrl = new URL(window.location.href);
			} catch (error) {
				return getCurrentPath();
			}

			nextUrl.searchParams.set('view', viewName);
			nextUrl.searchParams.delete('library_return');

			for (var i = 0; i < filterParamNames.length; i += 1) {
				nextUrl.searchParams.delete(filterParamNames[i]);
			}

			for (var group in selected) {
				if (Object.prototype.hasOwnProperty.call(selected, group)) {
					var values = selected[group];

					for (var j = 0; j < values.length; j += 1) {
						nextUrl.searchParams.append(group, values[j]);
					}
				}
			}

			return nextUrl.pathname + nextUrl.search + nextUrl.hash;
		}

		function updateLibraryUrl(options) {
			var nextPath = getLibraryStateUrl(options || {});

			if (nextPath === getCurrentPath()) {
				updateMoodboardCardLinks();
				return;
			}

			if (window.history && window.history.pushState) {
				window.history.pushState(null, '', nextPath);
				updateMoodboardCardLinks();
				return;
			}

			window.location.href = nextPath;
		}

		function getScrollTop() {
			return window.pageYOffset || document.documentElement.scrollTop || 0;
		}

		function getScrollStorageKey(returnUrl) {
			return 'libraryV2Scroll:' + returnUrl;
		}

		function saveReturnScroll(returnUrl) {
			try {
				window.sessionStorage.setItem(
					getScrollStorageKey(returnUrl),
					String(getScrollTop()),
				);
			} catch (error) {
				// Ignore browsers that block sessionStorage.
			}
		}

		function shouldWaitForScrollRestore() {
			var selected = collectSelectedFilters();
			var moodboardResults = root.querySelector(
				'[data-library-moodboard-results]',
			);

			return Boolean(
				isMoodboardViewActive() &&
				getSelectedGroupCount(selected) > 0 &&
				moodboardResults &&
				!moodboardResults.hidden &&
				!moodboardResultsAreLoaded(moodboardResults) &&
				moodboardResultsRequest,
			);
		}

		function restoreScrollIfReady() {
			var returnUrl;
			var storedValue;
			var scrollTop;

			if (!pendingScrollRestore || shouldWaitForScrollRestore()) {
				return;
			}

			returnUrl = getLibraryStateUrl();

			try {
				storedValue = window.sessionStorage.getItem(
					getScrollStorageKey(returnUrl),
				);
			} catch (error) {
				pendingScrollRestore = false;
				return;
			}

			if (!storedValue) {
				pendingScrollRestore = false;
				return;
			}

			scrollTop = parseInt(storedValue, 10);

			if (isNaN(scrollTop)) {
				try {
					window.sessionStorage.removeItem(getScrollStorageKey(returnUrl));
				} catch (error) {}

				pendingScrollRestore = false;
				return;
			}

			if (scrollRestoreTimer) {
				window.clearTimeout(scrollRestoreTimer);
			}

			scrollRestoreTimer = window.setTimeout(function () {
				window.scrollTo(0, scrollTop);

				try {
					window.sessionStorage.removeItem(getScrollStorageKey(returnUrl));
				} catch (error) {}

				pendingScrollRestore = false;
			}, 100);
		}

		function setMoodboardCardReturnUrl(link, returnUrl) {
			var articleUrl;

			if (!window.URL || !link || !returnUrl) {
				return;
			}

			try {
				articleUrl = new URL(link.getAttribute('href'), getWindowOrigin());
			} catch (error) {
				return;
			}

			if (
				articleUrl.protocol + '//' + articleUrl.host !== getWindowOrigin()
			) {
				return;
			}

			articleUrl.searchParams.set('library_return', returnUrl);
			link.setAttribute(
				'href',
				articleUrl.pathname + articleUrl.search + articleUrl.hash,
			);
		}

		function updateMoodboardCardLinks() {
			var returnUrl = getLibraryStateUrl();
			var links = root.querySelectorAll('a.library-v2__moodboard-card[href]');

			for (var i = 0; i < links.length; i += 1) {
				setMoodboardCardReturnUrl(links[i], returnUrl);
			}
		}

		function prepareMoodboardNavigation(link) {
			var returnUrl = getLibraryStateUrl();

			setMoodboardCardReturnUrl(link, returnUrl);
			saveReturnScroll(returnUrl);
		}

		function syncFromUrl() {
			var viewLoadPromise;

			applyFiltersFromUrl();

			if (typeof root.libraryV2SetView === 'function') {
				viewLoadPromise = root.libraryV2SetView(getUrlViewName(), false);
			}

			applyFilters();

			if (viewLoadPromise && typeof viewLoadPromise.then === 'function') {
				viewLoadPromise.then(function () {
					applyFilters();
				});
			}
		}

		function getFilterLabelFromText(text, value) {
			var label = text ? text.replace(/\s+/g, ' ').trim() : '';

			if (label) {
				return label;
			}

			return value.replace(/-/g, ' ');
		}

		function getCheckboxLabel(checkbox) {
			var label = checkbox.id
				? root.querySelector('label[for="' + checkbox.id + '"]')
				: null;

			if (!label) {
				label = closestElement(checkbox, 'label');
			}

			return getFilterLabelFromText(
				label ? label.textContent : '',
				checkbox.value,
			);
		}

		function getCollectionFilterLabel(value) {
			for (var i = 0; i < collectionFilters.length; i += 1) {
				var collectionFilter = collectionFilters[i];

				if (
					collectionFilter.getAttribute('data-library-collection-filter') ===
					value
				) {
					return getFilterLabelFromText(collectionFilter.textContent, value);
				}
			}

			return '';
		}

		function getCheckboxForFilter(group, value) {
			for (var i = 0; i < checkboxes.length; i += 1) {
				var checkbox = checkboxes[i];

				if (
					getFilterGroup(checkbox) === group &&
					normalizeValue(checkbox.value) === value
				) {
					return checkbox;
				}
			}

			return null;
		}

		function getActiveFilterLabel(group, value) {
			var checkbox = getCheckboxForFilter(group, value);
			var collectionFilterLabel;

			if (checkbox) {
				return getCheckboxLabel(checkbox);
			}

			if (group === 'collection') {
				collectionFilterLabel = getCollectionFilterLabel(value);

				if (collectionFilterLabel) {
					return collectionFilterLabel;
				}
			}

			return getFilterLabelFromText('', value);
		}

		function createActiveFilterChip(group, value, label) {
			var chip = document.createElement('h4');
			var close = document.createElement('a');

			chip.className = 'catalog__tags--active';
			chip.setAttribute('data-tag', value);
			chip.appendChild(document.createTextNode(label + ' '));

			close.href = '#';
			close.className = 'catalog__tags--close';
			close.setAttribute('aria-label', 'Remove ' + label + ' filter');
			close.setAttribute('data-library-active-filter-remove', '');
			close.setAttribute('data-library-active-filter-group', group);
			close.setAttribute('data-library-active-filter-value', value);
			close.innerHTML =
				'<svg viewBox="0 -9 40 40"><path class="close-x" d="M 10,10 L 30,30 M 30,10 L 10,30"></path></svg>';

			chip.appendChild(close);

			return chip;
		}

		function renderActiveFilters(selected) {
			var hasActiveFilters = false;

			if (!activeFilters) {
				return;
			}

			activeFilters.innerHTML = '';

			for (var group in selected) {
				if (Object.prototype.hasOwnProperty.call(selected, group)) {
					var values = selected[group];

					for (var i = 0; i < values.length; i += 1) {
						var value = values[i];
						activeFilters.appendChild(
							createActiveFilterChip(
								group,
								value,
								getActiveFilterLabel(group, value),
							),
						);
						hasActiveFilters = true;
					}
				}
			}

			activeFilters.hidden = !hasActiveFilters;
		}

		function removeActiveFilter(group, value) {
			var checkbox = getCheckboxForFilter(group, value);

			if (checkbox) {
				checkbox.checked = false;
			}

			if (group === 'collection' && selectedCollection === value) {
				selectedCollection = '';
			}

			if (group === 'effects' && moodboardExpandedEffect === value) {
				moodboardExpandedEffect = '';
				resetMoodboardEffectExpansions();
			}

			applyFilters();
			updateCollectionUrl();
		}

		function getMoodboardView() {
			return root.querySelector('[data-library-view="moodboard"]');
		}

		function isMoodboardViewActive() {
			var moodboardView = getMoodboardView();
			return Boolean(moodboardView && !moodboardView.hidden);
		}

		function moodboardResultsAreLoaded(moodboardResults) {
			return Boolean(
				moodboardResults &&
				moodboardResults.getAttribute(
					'data-library-moodboard-results-loaded',
				) === 'true',
			);
		}

		function renderMoodboardResultsLoader(moodboardResults) {
			var loaderHtml = '';

			for (var i = 0; i < 6; i += 1) {
				loaderHtml +=
					'<div class="grid__item article large--one-third medium-down--one-half library-v2__moodboard-item library-v2__moodboard-item--ghost">' +
					'<div class="library-v2__moodboard-card library-v2__moodboard-card--ghost">' +
					'<div class="library-v2__moodboard-image-placeholder"></div>' +
					'<div class="library-v2__moodboard-title-placeholder"></div>' +
					'</div>' +
					'</div>';
			}

			moodboardResults.innerHTML = loaderHtml;
			moodboardResults.classList.add('is-loading');
			moodboardResults.hidden = false;
		}

		function renderMoodboardResultsError(moodboardResults) {
			moodboardResults.innerHTML =
				'<div class="library-v2__moodboard-results-status">' +
				'<button type="button" class="library-v2__lazy-retry-button" data-library-moodboard-results-retry>' +
				'Retry loading moodboards' +
				'</button>' +
				'</div>';
			moodboardResults.classList.remove('is-loading');
			moodboardResults.hidden = false;
		}

		function ensureMoodboardResultsLoaded(callback) {
			var moodboardResults = root.querySelector(
				'[data-library-moodboard-results]',
			);
			var moodboardResultsUrl;

			if (!moodboardResults || moodboardResultsAreLoaded(moodboardResults)) {
				if (typeof callback === 'function') {
					callback();
				}

				return Promise.resolve(true);
			}

			if (moodboardResultsRequest) {
				return moodboardResultsRequest.then(function (loaded) {
					if (loaded && typeof callback === 'function') {
						callback();
					}

					return loaded;
				});
			}

			moodboardResultsUrl = moodboardResults.getAttribute(
				'data-library-moodboard-results-url',
			);

			if (!moodboardResultsUrl) {
				return Promise.resolve(false);
			}

			renderMoodboardResultsLoader(moodboardResults);

			moodboardResultsRequest = fetch(moodboardResultsUrl, {
				credentials: 'same-origin',
			})
				.then(function (response) {
					if (!response.ok) {
						throw new Error('Unable to load moodboard results');
					}

					return response.text();
				})
				.then(function (html) {
					moodboardResults.innerHTML = html;
					moodboardResults.setAttribute(
						'data-library-moodboard-results-loaded',
						'true',
					);
					moodboardResults.classList.remove('is-loading');
					moodboardCards = root.querySelectorAll(
						'[data-library-moodboard-card]',
					);
					moodboardResultsRequest = null;

					if (typeof callback === 'function') {
						callback();
					}

					return true;
				})
				.catch(function () {
					renderMoodboardResultsError(moodboardResults);
					moodboardResultsRequest = null;
					return false;
				});

			return moodboardResultsRequest;
		}

		function setMoodboardSeeMoreLoading(button, isLoading) {
			if (isLoading) {
				if (!button.getAttribute('data-library-moodboard-see-more-label')) {
					button.setAttribute(
						'data-library-moodboard-see-more-label',
						button.textContent,
					);
				}

				button.textContent = 'Loading...';
				button.disabled = true;
				button.setAttribute('aria-busy', 'true');
				return;
			}

			button.textContent =
				button.getAttribute('data-library-moodboard-see-more-label') ||
				'See More +';
			button.disabled = false;
			button.removeAttribute('aria-busy');
		}

		function showMoodboardSeeMoreError(button) {
			button.textContent = 'Retry loading';
			button.disabled = false;
			button.removeAttribute('aria-busy');
		}

		function resetMoodboardEffectExpansions() {
			var extraCards = root.querySelectorAll(
				'[data-library-moodboard-effect-extra]',
			);
			var seeMoreButtons = root.querySelectorAll(
				'[data-library-moodboard-see-more-loaded="true"]',
			);

			for (var i = 0; i < extraCards.length; i += 1) {
				if (extraCards[i].parentNode) {
					extraCards[i].parentNode.removeChild(extraCards[i]);
				}
			}

			for (var j = 0; j < seeMoreButtons.length; j += 1) {
				var button = seeMoreButtons[j];
				var buttonWrapper = button.parentNode;
				button.removeAttribute('data-library-moodboard-see-more-loaded');
				setMoodboardSeeMoreLoading(button, false);

				if (buttonWrapper) {
					buttonWrapper.hidden = false;
				}
			}
		}

		function loadMoodboardEffectResults(button) {
			var effectSection = closestElement(
				button,
				'[data-library-moodboard-effect]',
			);
			var effectGrid = effectSection
				? effectSection.querySelector('[data-library-moodboard-effect-grid]')
				: null;
			var effectGroup =
				button.getAttribute('data-library-moodboard-see-more-group') || '';
			var effectValue =
				button.getAttribute('data-library-moodboard-see-more-value') || '';
			var effectResultsUrl = button.getAttribute(
				'data-library-moodboard-effect-results-url',
			);

			if (
				!effectSection ||
				!effectGrid ||
				!effectGroup ||
				!effectValue ||
				!effectResultsUrl
			) {
				return Promise.resolve(false);
			}

			if (!selectSingleFilter(effectGroup, effectValue)) {
				return Promise.resolve(false);
			}

			selectedCollection = '';
			moodboardExpandedEffect = effectValue;
			syncMoodboardEffectSections(moodboardExpandedEffect);
			applyFilters();
			updateCollectionUrl();

			if (
				button.getAttribute('data-library-moodboard-see-more-loaded') === 'true'
			) {
				return Promise.resolve(true);
			}

			setMoodboardSeeMoreLoading(button, true);

			return fetch(effectResultsUrl, {
				credentials: 'same-origin',
			})
				.then(function (response) {
					if (!response.ok) {
						throw new Error('Unable to load moodboard effect results');
					}

					return response.text();
				})
				.then(function (html) {
					var wrapper = document.createElement('div');
					var buttonWrapper = button.parentNode;
					wrapper.innerHTML = html;

					while (wrapper.firstChild) {
						if (wrapper.firstChild.nodeType === 1) {
							wrapper.firstChild.setAttribute(
								'data-library-moodboard-effect-extra',
								'',
							);
						}

						effectGrid.appendChild(wrapper.firstChild);
					}

					button.setAttribute('data-library-moodboard-see-more-loaded', 'true');

					if (buttonWrapper) {
						buttonWrapper.hidden = true;
					}

					applyFilters();
					return true;
				})
				.catch(function () {
					showMoodboardSeeMoreError(button);
					return false;
				});
		}

		function deduplicateVisibleFiches() {
			var visibleProductHandles = {};
			ficheItems = root.querySelectorAll('[data-library-fiche-item]');

			for (var i = 0; i < ficheItems.length; i += 1) {
				var ficheItem = ficheItems[i];
				var productHandle = ficheItem.getAttribute(
					'data-library-product-handle',
				);

				if (!productHandle || ficheItem.hidden) {
					continue;
				}

				if (visibleProductHandles[productHandle]) {
					ficheItem.hidden = true;
					continue;
				}

				visibleProductHandles[productHandle] = true;
			}
		}

		function applyFilters() {
			var selected = collectSelectedFilters();
			var hasFilters = getSelectedGroupCount(selected) > 0;
			var selectedFicheFilters = getSelectedGroupsExcept(
				selected,
				'collection',
			);
			var hasFicheFilters = getSelectedGroupCount(selectedFicheFilters) > 0;
			var moodboardOverview;
			var moodboardResults;
			var hasLoadedMoodboardResults;
			var useExpandedMoodboardEffect =
				selectedMatchesExpandedMoodboardEffect(selected);

			for (
				var checkboxIndex = 0;
				checkboxIndex < checkboxes.length;
				checkboxIndex += 1
			) {
				var checkbox = checkboxes[checkboxIndex];
				var checkboxLabel = root.querySelector(
					'label[for="' + checkbox.id + '"]',
				);

				if (checkboxLabel) {
					checkboxLabel.classList.toggle('active', checkbox.checked);
				}
			}

			for (
				var filterIndex = 0;
				filterIndex < collectionFilters.length;
				filterIndex += 1
			) {
				var collectionFilter = collectionFilters[filterIndex];
				var collectionValue = collectionFilter.getAttribute(
					'data-library-collection-filter',
				);
				collectionFilter.classList.toggle(
					'active',
					collectionValue === selectedCollection,
				);
			}

			if (clearFilters) {
				clearFilters.hidden = !hasFilters;
			}

			renderActiveFilters(selected);

			if (typeof root.libraryV2SetActiveMaterialSources === 'function') {
				root.libraryV2SetActiveMaterialSources(
					getSelectedMaterialSources(selected),
				);
			}

			moodboardOverview = root.querySelector(
				'[data-library-moodboard-overview]',
			);
			moodboardResults = root.querySelector('[data-library-moodboard-results]');
			hasLoadedMoodboardResults = moodboardResultsAreLoaded(moodboardResults);

			if (moodboardOverview) {
				moodboardOverview.hidden =
					hasFilters &&
					!useExpandedMoodboardEffect &&
					(isMoodboardViewActive() || hasLoadedMoodboardResults);
			}

			if (moodboardResults) {
				if (!hasFilters || useExpandedMoodboardEffect) {
					moodboardResults.hidden = true;
				} else if (hasLoadedMoodboardResults) {
					moodboardResults.hidden = false;
				} else if (isMoodboardViewActive()) {
					moodboardResults.hidden = false;
					ensureMoodboardResultsLoaded(function () {
						applyFilters();
					});
				} else {
					moodboardResults.hidden = true;
				}
			}

			syncMoodboardEffectSections(
				useExpandedMoodboardEffect ? moodboardExpandedEffect : '',
			);

			ficheItems = root.querySelectorAll('[data-library-fiche-item]');

			for (var i = 0; i < ficheItems.length; i += 1) {
				var ficheItem = ficheItems[i];
				var ficheFilterTags =
					ficheItem.getAttribute('data-library-filter-tags') || '';
				var ficheCategoryTags =
					ficheItem.getAttribute('data-library-category-tags') || '';
				var categoryVisible =
					!selected.collection ||
					filterTagsMatchSelectedGroups(ficheCategoryTags, {
						collection: selected.collection,
					});
				var filterVisible =
					!hasFicheFilters ||
					filterTagsMatchSelectedGroups(ficheFilterTags, selectedFicheFilters);
				var isVisible = !hasFilters || (categoryVisible && filterVisible);
				ficheItem.hidden = !isVisible;
			}

			deduplicateVisibleFiches();

			for (var j = 0; j < collectionWrappers.length; j += 1) {
				var collection = collectionWrappers[j];
				var visibleItems = collection.querySelectorAll(
					'[data-library-fiche-item]:not([hidden])',
				);
				collection.hidden = visibleItems.length === 0;
			}

			moodboardCards = root.querySelectorAll('[data-library-moodboard-card]');

			for (var k = 0; k < moodboardCards.length; k += 1) {
				var card = moodboardCards[k];
				var cardFilterTags =
					card.getAttribute('data-library-filter-tags') || '';
				var moodboardVisible =
					!hasFilters ||
					filterTagsMatchSelectedGroups(cardFilterTags, selected);
				card.hidden = !moodboardVisible;
			}

			if (typeof root.libraryV2RefreshLazyFragments === 'function') {
				root.libraryV2RefreshLazyFragments();
			}

			updateMoodboardCardLinks();
			restoreScrollIfReady();
		}

		function updateCollectionUrl() {
			updateLibraryUrl();
		}

		function selectSingleFilter(group, value) {
			var normalizedValue = normalizeValue(value);
			var matchedFilter = false;

			for (
				var triggerIndex = 0;
				triggerIndex < checkboxes.length;
				triggerIndex += 1
			) {
				var checkbox = checkboxes[triggerIndex];
				var checkboxGroup =
					checkbox.getAttribute('data-library-filter-group') || 'availability';
				var checkboxValue = normalizeValue(checkbox.value);

				if (checkboxGroup === group) {
					checkbox.checked = checkboxValue === normalizedValue;

					if (checkbox.checked) {
						matchedFilter = true;
					}
				}
			}

			return matchedFilter;
		}

		function selectFilterTrigger(group, value) {
			if (!selectSingleFilter(group, value)) {
				return;
			}

			selectedCollection = '';
			moodboardExpandedEffect = '';
			resetMoodboardEffectExpansions();
			applyFilters();
			updateCollectionUrl();
		}

		for (var i = 0; i < checkboxes.length; i += 1) {
			checkboxes[i].addEventListener('change', function (event) {
				moodboardExpandedEffect = '';
				resetMoodboardEffectExpansions();
				applyFilters();
				updateCollectionUrl();
			});
		}

		for (var j = 0; j < collectionFilters.length; j += 1) {
			collectionFilters[j].addEventListener('click', function (event) {
				event.preventDefault();

				var collectionValue =
					event.currentTarget.getAttribute('data-library-collection-filter') ||
					'';
				selectedCollection = collectionValue;
				moodboardExpandedEffect = '';
				resetMoodboardEffectExpansions();

				applyFilters();
				updateCollectionUrl();
			});
		}

		if (clearFilters) {
			clearFilters.addEventListener('click', function (event) {
				event.preventDefault();

				selectedCollection = '';
				moodboardExpandedEffect = '';
				resetMoodboardEffectExpansions();

				for (
					var clearIndex = 0;
					clearIndex < checkboxes.length;
					clearIndex += 1
				) {
					checkboxes[clearIndex].checked = false;
				}

				applyFilters();
				updateCollectionUrl();
			});
		}

		if (activeFilters) {
			activeFilters.addEventListener(
				'click',
				function (event) {
					var removeTrigger = closestElement(
						event.target,
						'[data-library-active-filter-remove]',
					);

					if (!removeTrigger) {
						return;
					}

					event.preventDefault();
					event.stopPropagation();
					removeActiveFilter(
						removeTrigger.getAttribute('data-library-active-filter-group') ||
							'',
						removeTrigger.getAttribute('data-library-active-filter-value') ||
							'',
					);
				},
				true,
			);
		}

		root.addEventListener('click', function (event) {
			var resultsRetry = closestElement(
				event.target,
				'[data-library-moodboard-results-retry]',
			);
			var moodboardSeeMore = closestElement(
				event.target,
				'[data-library-moodboard-see-more]',
			);
			var moodboardLink = closestElement(
				event.target,
				'a.library-v2__moodboard-card[href]',
			);
			var filterTrigger = closestElement(
				event.target,
				'[data-library-filter-trigger-group]',
			);

			if (resultsRetry) {
				event.preventDefault();
				ensureMoodboardResultsLoaded(function () {
					applyFilters();
				});
				return;
			}

			if (moodboardSeeMore) {
				event.preventDefault();
				selectFilterTrigger(
					moodboardSeeMore.getAttribute(
						'data-library-moodboard-see-more-group',
					) || '',
					moodboardSeeMore.getAttribute(
						'data-library-moodboard-see-more-value',
					) || '',
				);
				return;
			}

			if (moodboardLink) {
				prepareMoodboardNavigation(moodboardLink);
				return;
			}

			if (!filterTrigger) {
				return;
			}

			event.preventDefault();
			selectFilterTrigger(
				filterTrigger.getAttribute('data-library-filter-trigger-group') || '',
				filterTrigger.getAttribute('data-library-filter-trigger-value') || '',
			);
		});

		filterParamNames = getFilterParamNames();
		applyFiltersFromUrl();

		root.libraryV2GetSelectedMaterialSources = function () {
			return getSelectedMaterialSources(collectSelectedFilters());
		};

		root.libraryV2UpdateUrl = updateLibraryUrl;
		root.libraryV2ApplyFilters = applyFilters;

		if (window.addEventListener) {
			window.addEventListener('popstate', syncFromUrl);
		}

		applyFilters();
	}

	function initMoqModal() {
		var modal = document.getElementById('libraryV2MoqModal');
		var imageElement = modal
			? document.getElementById('libraryV2MoqModalImage')
			: null;
		var titleElement = modal
			? document.getElementById('libraryV2MoqModalTitle')
			: null;
		var collectionElement = modal
			? document.getElementById('libraryV2MoqModalCollection')
			: null;
		var moodboardLink = modal
			? document.getElementById('libraryV2MoqModalMoodboard')
			: null;

		function getProductViewUrl(productUrl) {
			var url = productUrl || '';
			var hash = '';
			var hashIndex = url.indexOf('#');

			if (!url) {
				return '';
			}

			if (hashIndex !== -1) {
				hash = url.slice(hashIndex);
				url = url.slice(0, hashIndex);
			}

			return (
				url +
				(url.indexOf('?') === -1 ? '?' : '&') +
				'view=library-moq-fiche-modal' +
				hash
			);
		}

		function closeFicheModal(ficheModal) {
			var activeCard;

			if (!ficheModal) {
				return;
			}

			activeCard = ficheModal.querySelector('.hal-productCard.active');
			ficheModal.classList.remove('active');
			ficheModal.setAttribute('aria-hidden', 'true');

			if (activeCard) {
				activeCard.classList.remove('active');
			}

			if (!document.querySelector('.library-v2__fiche-modal.active')) {
				document.body.classList.remove('library-v2-modal-open');
			}
		}

		function closeModal() {
			var activeFicheModal = document.querySelector(
				'.library-v2__fiche-modal.active',
			);

			if (modal) {
				modal.hidden = true;
			}

			closeFicheModal(activeFicheModal);
			document.body.classList.remove('library-v2-modal-open');
		}

		function openFicheModalElement(ficheModal) {
			var card = ficheModal
				? ficheModal.querySelector('.hal-productCard')
				: null;

			if (!ficheModal || !card) {
				return false;
			}

			closeModal();
			ficheModal.classList.add('active');
			ficheModal.setAttribute('aria-hidden', 'false');
			card.classList.add('active');
			document.body.classList.add('library-v2-modal-open');

			return true;
		}

		function getFicheModalForTrigger(trigger) {
			var ficheModalTarget = trigger.getAttribute(
				'data-library-fiche-modal-target',
			);
			var ficheModal = ficheModalTarget
				? document.getElementById(ficheModalTarget)
				: null;
			var fiche = closestElement(trigger, '[data-library-fiche-item]');
			var modalUrl = trigger.getAttribute('data-library-fiche-modal-url') || '';

			if (!ficheModal && fiche) {
				ficheModal = fiche.querySelector('[data-library-fiche-modal]');
			}

			if (!ficheModal && (ficheModalTarget || modalUrl)) {
				ficheModal = document.createElement('div');
				ficheModal.className =
					'hal-productCard--wrapper library-v2__fiche-modal';
				ficheModal.setAttribute('data-library-fiche-modal', '');
				ficheModal.setAttribute('aria-hidden', 'true');

				if (ficheModalTarget) {
					ficheModal.id = ficheModalTarget;
				}

				document.body.appendChild(ficheModal);
			}

			if (
				ficheModal &&
				modalUrl &&
				!ficheModal.getAttribute('data-library-fiche-modal-url')
			) {
				ficheModal.setAttribute('data-library-fiche-modal-url', modalUrl);
			}

			return ficheModal;
		}

		function getFicheModalUrl(trigger, ficheModal) {
			return (
				trigger.getAttribute('data-library-fiche-modal-url') ||
				(ficheModal
					? ficheModal.getAttribute('data-library-fiche-modal-url')
					: '') ||
				getProductViewUrl(trigger.getAttribute('href') || '')
			);
		}

		function setFicheModalLoading(ficheModal, isLoading) {
			ficheModal.classList.toggle('is-loading', isLoading);

			if (isLoading) {
				ficheModal.setAttribute('aria-busy', 'true');
			} else {
				ficheModal.removeAttribute('aria-busy');
			}
		}

		function loadFicheModal(trigger, ficheModal) {
			var modalUrl = getFicheModalUrl(trigger, ficheModal);

			if (!ficheModal || !modalUrl || !window.fetch) {
				return Promise.reject(new Error('Unable to load MOQ modal'));
			}

			if (
				ficheModal.getAttribute('data-library-fiche-modal-loaded') === 'true' ||
				ficheModal.querySelector('.hal-productCard')
			) {
				return Promise.resolve(ficheModal);
			}

			if (ficheModal.libraryMoqModalRequest) {
				return ficheModal.libraryMoqModalRequest;
			}

			ficheModal.setAttribute('data-library-fiche-modal-url', modalUrl);
			setFicheModalLoading(ficheModal, true);

			ficheModal.libraryMoqModalRequest = fetch(modalUrl, {
				credentials: 'same-origin',
			})
				.then(function (response) {
					if (!response.ok) {
						throw new Error('Unable to load MOQ modal');
					}

					return response.text();
				})
				.then(function (html) {
					ficheModal.innerHTML = html;

					if (!ficheModal.querySelector('.hal-productCard')) {
						ficheModal.innerHTML = '';
						throw new Error('Invalid MOQ modal response');
					}

					ficheModal.setAttribute('data-library-fiche-modal-loaded', 'true');
					setFicheModalLoading(ficheModal, false);
					return ficheModal;
				})
				.catch(function (error) {
					ficheModal.libraryMoqModalRequest = null;
					setFicheModalLoading(ficheModal, false);
					throw error;
				});

			return ficheModal.libraryMoqModalRequest;
		}

		function navigateToTriggerHref(trigger) {
			var triggerHref = trigger.getAttribute('href');

			if (triggerHref) {
				window.location.href = triggerHref;
			}
		}

		function openLazyFicheModal(trigger) {
			var ficheModal = getFicheModalForTrigger(trigger);

			if (!ficheModal) {
				return false;
			}

			if (openFicheModalElement(ficheModal)) {
				return true;
			}

			loadFicheModal(trigger, ficheModal)
				.then(function (loadedFicheModal) {
					openFicheModalElement(loadedFicheModal);
				})
				.catch(function () {
					navigateToTriggerHref(trigger);
				});

			return true;
		}

		function activateFicheTab(tabTrigger) {
			var ficheModal = closestElement(tabTrigger, '[data-library-fiche-modal]');
			var selectedTab = tabTrigger.getAttribute('data-library-fiche-tab');
			var tabTriggers;
			var tabPanels;
			var i;

			if (!ficheModal || !selectedTab) {
				return;
			}

			tabTriggers = ficheModal.querySelectorAll('[data-library-fiche-tab]');
			tabPanels = ficheModal.querySelectorAll('[data-library-fiche-tab-panel]');

			for (i = 0; i < tabTriggers.length; i += 1) {
				var tabIsActive =
					tabTriggers[i].getAttribute('data-library-fiche-tab') === selectedTab;
				tabTriggers[i].classList.toggle('active', tabIsActive);
				tabTriggers[i].setAttribute(
					'aria-selected',
					tabIsActive ? 'true' : 'false',
				);
			}

			for (i = 0; i < tabPanels.length; i += 1) {
				tabPanels[i].classList.toggle(
					'active',
					tabPanels[i].getAttribute('data-library-fiche-tab-panel') ===
						selectedTab,
				);
			}
		}

		function openModal(trigger) {
			var image = trigger.getAttribute('data-product-image') || '';
			var title = trigger.getAttribute('data-product-title') || '';
			var collection = trigger.getAttribute('data-collection-title') || '';
			var moodboardUrl = trigger.getAttribute('data-moodboard-url') || '';

			if (
				!modal ||
				!imageElement ||
				!titleElement ||
				!collectionElement ||
				!moodboardLink
			) {
				return;
			}

			imageElement.src = image;
			imageElement.alt = title;
			titleElement.textContent = title;
			collectionElement.textContent = collection;

			if (moodboardUrl) {
				moodboardLink.hidden = false;
				moodboardLink.href = moodboardUrl;
			} else {
				moodboardLink.hidden = true;
			}

			modal.hidden = false;
			document.body.classList.add('library-v2-modal-open');
		}

		document.addEventListener('click', function (event) {
			var openTrigger = closestElement(event.target, '[data-library-moq-card]');
			var closeTrigger = closestElement(
				event.target,
				'[data-library-fiche-modal-close]',
			);
			var tabTrigger = closestElement(event.target, '[data-library-fiche-tab]');

			if (tabTrigger) {
				event.preventDefault();
				activateFicheTab(tabTrigger);
				return;
			}

			if (openTrigger) {
				if (openLazyFicheModal(openTrigger)) {
					event.preventDefault();
					return;
				}

				if (modal) {
					event.preventDefault();
					openModal(openTrigger);
				}

				return;
			}

			if (closeTrigger) {
				event.preventDefault();
				closeFicheModal(
					closestElement(closeTrigger, '[data-library-fiche-modal]'),
				);
				return;
			}

			if (closestElement(event.target, '[data-library-moq-close]')) {
				event.preventDefault();
				closeModal();
			}
		});

		document.addEventListener('keydown', function (event) {
			var isEscape = event.key === 'Escape' || event.keyCode === 27;
			var activeFicheModal = document.querySelector(
				'.library-v2__fiche-modal.active',
			);

			if (isEscape && ((modal && !modal.hidden) || activeFicheModal)) {
				closeModal();
			}
		});
	}

	function initLibraryReturnLink() {
		var returnUrl;
		var returnLink;
		var link;

		if (!window.URLSearchParams) {
			return;
		}

		returnUrl =
			new URLSearchParams(window.location.search).get('library_return') || '';

		if (
			!returnUrl ||
			returnUrl.charAt(0) !== '/' ||
			returnUrl.indexOf('//') === 0 ||
			returnUrl.indexOf('\\') !== -1
		) {
			return;
		}

		link = document.createElement('a');
		link.href = returnUrl;

		if (
			link.protocol + '//' + link.host !== getWindowOrigin() ||
			(link.pathname !== '/blogs/library' &&
				link.pathname.indexOf('/blogs/library/') !== 0)
		) {
			return;
		}

		returnLink = document.querySelector('.return-link');

		if (returnLink) {
			returnLink.href = link.pathname + link.search + link.hash;
		}
	}

	function initBackToTop(root) {
		var button = root.querySelector('[data-library-back-to-top]');
		var scrollThreshold = 80;
		var ticking = false;

		if (!button) {
			return;
		}

		function getScrollTop() {
			return window.pageYOffset || document.documentElement.scrollTop || 0;
		}

		function shouldReduceMotion() {
			return (
				window.matchMedia &&
				window.matchMedia('(prefers-reduced-motion: reduce)').matches
			);
		}

		function setButtonVisible(isVisible) {
			button.classList.toggle('is-visible', isVisible);
			button.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
			button.tabIndex = isVisible ? 0 : -1;
		}

		function updateButtonVisibility() {
			ticking = false;
			setButtonVisible(getScrollTop() > scrollThreshold);
		}

		function requestVisibilityUpdate() {
			if (ticking) {
				return;
			}

			ticking = true;

			if (window.requestAnimationFrame) {
				window.requestAnimationFrame(updateButtonVisibility);
			} else {
				window.setTimeout(updateButtonVisibility, 16);
			}
		}

		button.addEventListener('click', function () {
			try {
				window.scrollTo({
					top: 0,
					behavior: shouldReduceMotion() ? 'auto' : 'smooth',
				});
			} catch (error) {
				window.scrollTo(0, 0);
			}
		});

		window.addEventListener('scroll', requestVisibilityUpdate);
		updateButtonVisibility();
	}

	onReady(function () {
		var libraryRoots = document.querySelectorAll('[data-library-v2]');

		for (var i = 0; i < libraryRoots.length; i += 1) {
			initBackToTop(libraryRoots[i]);
			initLibraryFilters(libraryRoots[i]);
			initViewSwitch(libraryRoots[i]);
		}

		initMoqModal();
		initLibraryReturnLink();
	});
})();
